const RenderEmptyBlock = () => {
  return null;
};

export default RenderEmptyBlock;
